
const CrudCodeValues = require("./CrudCodeValues");
module.exports = {
    START: "START",
    PROD: "PROD",
    DELIV: "DELIV",
    ASSY: "ASSY",
    ENDITEM: "ENDITEM"
};
